import { useEffect, useState } from 'react';
import Api from './api';
import useApi from './useApi';

const useInitialFetch = (
  makeRequest: (api: Api) => Promise<void>,
  deps: unknown[] = []
): boolean => {
  const api = useApi();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const controller = new AbortController();

    const fetch = async () => {
      setLoading(true);

      try {
        await makeRequest(api);
      } catch (error: unknown) {
        // handle error in the future
      } finally {
        setLoading(false);
      }
    };

    fetch();

    return () => controller.abort();
  }, deps);

  return loading;
};

export default useInitialFetch;
